import { travelerForm } from '@eti/travelers';

const { FREQUENT_FLYER_CARD_NUMBER, FREQUENT_FLYER_CARD_TYPE } = travelerForm;

type FrequentFlyerFormSelection = {
  cardNumber: string;
  cardType: string;
};

export const getFrequentFlyerData = (formSelection?: FrequentFlyerFormSelection) => {
  return formSelection
    ? {
        frequentFlyerCardNumber: formSelection[FREQUENT_FLYER_CARD_NUMBER],
        frequentFlyerCardId: formSelection[FREQUENT_FLYER_CARD_TYPE],
      }
    : null;
};
